import { useState } from "react";

interface NotesFieldProps {
  value: string;
  onSave: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  minRows?: number;
}

/** Textarea that saves on blur when the value changed. Mirrors the renewals
 *  NotesField pattern. Keyed by the incoming value so external updates reset
 *  the draft. */
export function NotesField({ value, onSave, placeholder, disabled, minRows = 2 }: NotesFieldProps) {
  const [draft, setDraft] = useState(value);
  return (
    <textarea
      key={value}
      className="block w-full resize-y rounded-xl border border-input bg-background px-2.5 py-2 text-sm disabled:opacity-50"
      style={{ minHeight: `${minRows * 1.6}rem` }}
      defaultValue={value}
      placeholder={placeholder ?? "Notes…"}
      disabled={disabled}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={() => {
        if (draft !== value) onSave(draft);
      }}
    />
  );
}
